export default __webpack_public_path__ + "static/media/330_store01-es-web.a0cd03a8.png";